import { render, staticRenderFns } from "./SalonNavigation.vue?vue&type=template&id=15573a4a&scoped=true"
import script from "./SalonNavigation.vue?vue&type=script&lang=js"
export * from "./SalonNavigation.vue?vue&type=script&lang=js"
import style0 from "./SalonNavigation.vue?vue&type=style&index=0&id=15573a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15573a4a",
  null
  
)

export default component.exports